define('app/config',['require'],function(require){
	return {
		endpoint: "http://www.verticeiluminacao.com.br"
	};
});
